// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__8EuJY","title":"Home_title__49oHQ","subtitle":"Home_subtitle__f5W2i"};